import { object, string } from 'zod';

import { CHARACTER_LIMIT_EXCEEDED, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const schema = object({
  name: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(200, CHARACTER_LIMIT_EXCEEDED),
  description: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(200, CHARACTER_LIMIT_EXCEEDED),
});
